import React from 'react';
import PropTypes from 'prop-types';
import Redirect from 'react-router-dom/Redirect';
import hoistStatics from 'hoist-non-react-statics';
import qs from 'qs';

export default Component => {
  const C = ({ location: { pathname, search }, ...props }) => {
    let { token } = qs.parse(search.replace(/^\?/, ''));
    // save token for later if user isn't logged in.
    if (typeof localStorage !== 'undefined') {
      if (token) {
        localStorage.setItem('authToken', token);
        return <Redirect to={pathname} />;
      }
      token = localStorage.getItem('authToken');
    }
    try {
      const {
        userId,
        spaceId,
      } = JSON.parse(atob(token.split('.')[1]));
      return (
        <Component
          {...props}
          userId={userId}
          spaceId={spaceId}
        />
      );
    } catch (err) {
      return <Component {...props} />;
    }
  };
  C.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }).isRequired,
  };
  C.displayName = `withInvite(${Component.displayName || Component.name})`;
  return hoistStatics(C, Component);
};



// WEBPACK FOOTER //
// ./src/helpers/withInvite.js